import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  leads: [],
  pages: 0,
};

const leadsSlice = createSlice({
  name: "leads",
  initialState,
  reducers: {
    setLeads(state, action) {
      state.leads = action.payload;
    },
    setPages(state, action) {
      state.pages = action.payload;
    },
    addLead(state, action) {
      state.leads.push(action.payload);
    },
  },
});

export function getLeads({ page, pageSize }) {
  return async (dispatch) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) return Promise.reject("No access token");
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/lead`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            page: page,
            pageSize: pageSize,
          },
        }
      );
      dispatch(leadsSlice.actions.setLeads(response.data.data.data));
      dispatch(leadsSlice.actions.setPages(response.data.data.pages));
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(leadsSlice.actions.setLeads([]));
      dispatch(leadsSlice.actions.setPages(0));
    }
  };
}

export async function createLead({ data }) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/lead`,
      data,
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_POS2CLOUD_BACKEND_BASIC_HEADER}`,
        },
      }
    );
    return Promise.resolve(response.data.message);
  } catch (error) {
    return Promise.reject(error.message);
  }
}

export default leadsSlice.reducer;
